import SessionEventProto from "../session-event-proto"
import {MyWorkType} from "../../../app/home/my-work/common/model/@const"

export default class SessionEvent_MyWorkChange extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {
        if (this.isDifferentCompany()) {
            return
        }

        if (!gd.session.myWork) return

        try {
            const myWork = gd.session.myWork.get(this.data.id)

            if (myWork) {
                myWork.reset(this.data)
                gd.session.myWork.trigger("reset")
                gd.session.myWork.folder(myWork.folder).trigger("reset")
                gd.bus.triggerEvent('gd.session.myWork:reset')

                if (gd.session.assignedTasks && gd.session.assignedTasks.planning && myWork.task) {
                    const assignedTask = gd.session.assignedTasks.getTask(myWork.task.id)
                    if (assignedTask) {
                        assignedTask.scheduleStatus = myWork.task.scheduleStatus
                        assignedTask.scheduleDate   = myWork.task.scheduleDate
                    }
                }

                // temporary solution for new my work (for dateCreated, isNew and fromUserId)
                if (this.data.task) {
                    gd.modelBus.newUpdate('my-work-task', 'delta', this.data.task.id, _.assign({}, this.data.task, {
                        properties: {
                            'myWork': {
                                'actionRequired': {
                                    sinceMoment : this.data.dateCreated,
                                    isNew       : this.data.isNew,
                                    fromUserId  : this.data.fromUserId,
                                }
                            }
                        }
                    }), {
                        task        : this.data.task,
                        isBulkUpdate: true,
                    })
                }

                if (this.data.type === MyWorkType.TODO) {
                    gd.modelBus.newUpdate('my-work-todo', 'delta', this.data.id, _.assign({}, this.data), {
                        todo            : this.data,
                        isBulkUpdate    : true,
                    })
                }
            }
        } catch (err) {
            gd.utils.captureErrorMessage('EventMyWorkChange error', {
                level: 'error',
                extra: {
                    this : this,
                    error: err,
                }
            })
        }
    }

}
